import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <small>© 2021 Jasmine Lopez</small>
    </footer>
  )
}

export default Footer;